import { BuildingsIconComponent } from 'assets/icons/buildings';
import { Card } from 'antd';
import { CompanyForm } from './components/CompanyForm';
import { CreateLayout } from 'components/layout/layout/CreateLayout';
import { HttpError } from '@refinedev/core';
import { ICompany } from 'interfaces/companies';
import { PageHeader } from 'components/professor_area/PageHeader';
import { useForm } from '@refinedev/antd';

export const CompanyCreate = () => {
  const { formProps, saveButtonProps } = useForm<
    ICompany,
    HttpError,
    ICompany
  >();

  return (
    <CreateLayout saveButtonProps={saveButtonProps} title="Nova unidade">
      <PageHeader title="Nova unidade" icon={BuildingsIconComponent} />

      <Card>
        <CompanyForm formProps={formProps} />
      </Card>
    </CreateLayout>
  );
};
